export default {
  buildUpdate(id, label, active, text, attachment) {
    return {
      'data': {
        'attributes': {
          'label': label,
          'active': active,
          'text': text,
          'attachment': attachment,
        },
        'type': 'message-template',
        'id': id,
      },
    };
  },
  buildCreate(label, active, text, attachment) {
    return {
      'data': {
        'attributes': {
          'label': label,
          'active': active,
          'text': text,
          'attachment': attachment,
        },
        'type': 'message-template',
      },
    };
  },
  async fetchAllMessages(axios, token) {
    return await axios.get('/api/message/message-templates/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async createMessage(data, axios, token) {
    return await axios.post('/api/message/message-templates/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async deleteMessage(messageId, axios, token) {
    return await axios.delete(`/api/message/message-templates/${messageId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async updateMessage(messageId, data, axios, token) {
    return await axios.patch(`/api/message/message-templates/${messageId}/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
